export default {
  init() {

  },
  finalize() {
    // Set correct URL for language options
    if ($('#top-header-lang-en').length > 0) {
      const enUrl = $('.links-language-switcher .wpml-ls-item-en .wpml-ls-link').attr('href');

      if (enUrl) {
        $('#top-header-lang-en').attr('href', enUrl);
      } else {
        $('#top-header-lang-en').remove();
      }
    }
    
    if ($('#top-header-lang-cy').length > 0) {
      const cyUrl = $('.links-language-switcher .wpml-ls-item-cy .wpml-ls-link').attr('href');

      if (cyUrl) {
        $('#top-header-lang-cy').attr('href', cyUrl);
      } else {
        $('#top-header-lang-cy').remove();
      }
    }
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/other/navigation.js